import Signer from "./components/signer";

function SignPage(): React.JSX.Element {
  return <Signer />;
}

export default SignPage;
